import React from "react";
import { ScreenGtLg, ScreenLtLg } from "app/components/MediaQueries";
import env from "helpers/env";
import { SubscriptionProvider, AccessType } from "services/graphql";
import { usePrimarySubscription } from "hooks/Subscriptions/usePrimarySubscription";
import { DesktopSubscribeModalWrapper } from "./DesktopSubscribeModalWrapper";
import { MobileSubscribeModalWrapper } from "./MobileSubscribeModalWrapper";
import { UpgradePlanFLow } from "./UpgradePlanFlow";
import { StartSubscriptionFlow } from "./StartSubscriptionFlow";
import { SubscribeModalContext } from "./context";
import { ReactivateSubscriptionFlow } from "./ReactivateSubscriptionFlow";
import { MobileSubscriberModal } from "./MobileSubscriberModal";

interface Props {
  closeModal(): void;
  isOpen: boolean;
}

export const SubscribeModal = ({ isOpen, closeModal }: Props) => {
  const { primarySubscription } = usePrimarySubscription();
  const { isActive: isSubscriptionActive } = primarySubscription || {};

  if (!isOpen) {
    return null;
  }

  const previewSrc = `${env(
    "PUBLIC_ASSET_PATH"
  )}/onboarding/checkout-screen.jpg`;

  const accessType = AccessType.Standard;
  const accessHeader =
    "Subscribe now to get access to our classes and programs!";

  const canReactivate = primarySubscription?.isReactivatableV2;
  const checkoutHeader =
    !isSubscriptionActive && canReactivate
      ? "Reactivate your subscription"
      : "Start your subscription";
  const canUpgrade = isSubscriptionActive && !canReactivate;
  const previewHeader = canUpgrade
    ? "Upgrade your subscription"
    : checkoutHeader;
  const CheckoutFlow = canReactivate
    ? ReactivateSubscriptionFlow
    : StartSubscriptionFlow;
  const SubscribeFlow = canUpgrade ? UpgradePlanFLow : CheckoutFlow;

  if (
    !isSubscriptionActive &&
    primarySubscription?.provider?.name === SubscriptionProvider.Revenuecat
  ) {
    return <MobileSubscriberModal closeModal={closeModal} />;
  }

  return (
    <SubscribeModalContext.Provider value={{ closeModal }}>
      <ScreenGtLg>
        <DesktopSubscribeModalWrapper
          closeModal={closeModal}
          previewSrc={previewSrc}
          previewHeader={previewHeader}
          accessHeader={accessHeader}
        >
          <SubscribeFlow accessTypeRequired={accessType} />
        </DesktopSubscribeModalWrapper>
      </ScreenGtLg>
      <ScreenLtLg>
        <MobileSubscribeModalWrapper
          closeModal={closeModal}
          accessHeader={accessHeader}
        >
          <SubscribeFlow accessTypeRequired={accessType} />
        </MobileSubscribeModalWrapper>
      </ScreenLtLg>
    </SubscribeModalContext.Provider>
  );
};
